module.exports = "/images/Japan.png?894e136af4dde503c2a855542b3576a2";